module.exports = __webpack_public_path__ + "static/media/Wasgamuwa.5a0f263b.png";